import { formatInTimeZone } from 'date-fns-tz';
import { asDateInTZ } from './convertToISO';
import zipcode_to_timezone from 'zipcode-to-timezone';

export const getOrderTimezone = (order) => {
    const zip = order.order_type === 'return' ? order.pickup_zip : order.dropoff_zip;

    return zipcode_to_timezone.lookup(zip) || 'America/New_York';
};

export const formatDateInTimezone = (date, timezone, dateFormat) => {
    if (!date) {
        return null;
    }

    return formatInTimeZone(asDateInTZ(date, timezone), timezone, dateFormat);
};

//get formatted date fields for order when not accessible from cache (subscriptions)
export const addFormattedDateFields = (order) => {
    const timezone = getOrderTimezone(order);
    const formatDate = (date) => formatDateInTimezone(date, timezone, 'EEE, MMM d, yyyy');

    return {
        delivery_date_formatted: formatDate(order.delivery_date),
        pickup_date_formatted: formatDate(order.pickup_date),
        preferred_delivery_date_formatted: formatDate(order.preferred_delivery_date),
        estimated_delivery_range_start_formatted: formatDate(order.estimated_delivery_range_start),
        estimated_delivery_range_end_formatted: formatDate(order.estimated_delivery_range_end),
        alternative_delivery_dates_formatted: order.alternative_delivery_dates
            ? order.alternative_delivery_dates.map(formatDate)
            : null,
    };
};
